module.exports = __webpack_public_path__ + "img/goal-14.edbbacde.png";